import { render, staticRenderFns } from "./EditAssetOfAssetModuleFormComponent.vue?vue&type=template&id=05f182a9&"
import script from "./EditAssetOfAssetModuleFormComponent.vue?vue&type=script&lang=js&"
export * from "./EditAssetOfAssetModuleFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetOfAssetModuleFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports